import { InvoicesColumns } from "@portal/BaseComponents/Table/Components/Invoices/InvoicesColumn";
import { Formats } from "@portal/hooks/use-formats";
import { PTPList } from "@portal/types/entities/ptp";
import { GridColumnProps } from "@sinecycle/growcomponents";
import { useMemo } from "react";
import { PtpIDCell } from "./PTPId/PtpIDCell";
import { getPTPStatusConfig } from "./predicate";

function useColumns(extra: Formats) {
  function handleColumns() {
    const columns: GridColumnProps<PTPList> = [
      {
        colId: "ID",
        headerName: "PTP ID",
        cellRenderer: PtpIDCell,
        pinned: "left",
        width: 140,
      },
      {
        colId: "PTP_DATE",
        headerName: "PTP Date",
        field: "pay_date",
        cellRenderer: "dateCell",
        sortable: true,
        cellRendererParams: {
          dateCellProps: {
            format: extra.dateformat,
          },
        },
      },
      {
        colId: "PTP_BALANCE",
        headerName: "PTP Balance Amount",
        cellRenderer: "amountCell",
        field: "balance_amount",
        cellClass: "ag-right-aligned-cell",
        headerClass: "ag-right-aligned-header",
        cellRendererParams: {
          amountTextProps: {
            locale: extra.locale,
          },
        },
        valueGetter: (params) => {
          return {
            amount: params?.data?.balance_amount,
            currency: params?.data?.currency,
          };
        },
      },
      {
        colId: "PTP_AMOUNT",
        headerName: "PTP Amount",
        cellRenderer: "amountCell",
        field: "amount",
        cellClass: "ag-right-aligned-cell",
        headerClass: "ag-right-aligned-header",
        cellRendererParams: {
          amountTextProps: {
            locale: extra.locale,
          },
        },
        valueGetter: (params) => {
          return {
            amount: params?.data?.amount,
            currency: params?.data?.currency,
          };
        },
      },
      {
        colId: "STATUS",
        headerName: "PTP Status",
        cellRenderer: "statusCell",
        field: "status",
        cellRendererParams: {
          statusCellProps: {
            getter: getPTPStatusConfig,
          },
        },
      },
      {
        colId: "INVOICES",
        headerName: "Associated Invoice",
        cellRenderer: "invoices",
        field: "invoice",
        valueGetter: (params) => {
          function getInvoices(): InvoicesColumns[] {
            if (!params.data?.invoice) return [];
            return [params.data.invoice].map((invoice) => {
              return {
                id: invoice.id,
                title: invoice.number,
                amount: invoice.amount,
                currency: invoice.currency,
              };
            });
          }
          return getInvoices();
        },
      },
      {
        colId: "INVOICE_BALANCE",
        headerName: "Invoice Due Amount",
        cellRenderer: "amountCell",
        cellRendererParams: {
          amountTextProps: {
            locale: extra.locale,
          },
        },
        cellClass: "ag-right-aligned-cell",
        headerClass: "ag-right-aligned-header",
        field: "invoice.balance_due_amount",
        valueGetter: (params) => {
          if (!params?.data?.invoice) return undefined;
          return {
            amount: params.data.invoice.balance_due_amount,
            currency: params.data.invoice.currency,
          };
        },
      },
      {
        colId: "INVOICE_Amount",
        headerName: "Invoice Amount",
        cellRenderer: "amountCell",
        cellClass: "ag-right-aligned-cell",
        headerClass: "ag-right-aligned-header",
        field: "invoice.amount",
        cellRendererParams: {
          amountTextProps: {
            locale: extra.locale,
          },
        },
        valueGetter: (params) => {
          if (!params?.data?.invoice) return undefined;
          return {
            amount: params.data.invoice.amount,
            currency: params.data.invoice.currency,
          };
        },
      },
      // {
      //   headerComponentParams: {
      //     matchKey: "id",
      //     sorting: false,
      //   },
      //   headerName: "Invoice Status",
      //
      //   cellRenderer: InvoiceStatusCell,
      // },
      // {
      //   colId: "CLOSED_DATE",
      //   headerComponentParams: {
      //     matchKey: "id",
      //     sorting: true,
      //   },
      //   headerName: "PTP Closed Date",
      //
      //   cellRenderer: PTPClosedDateCell,
      // },
      // {
      //   colId: "Comment",
      //   headerComponentParams: {
      //     matchKey: "id",
      //     sorting: false,
      //   },
      //   cellRenderer: AddComment,
      // },
    ];
    return columns;
  }

  const defaultColConfigs = useMemo(handleColumns, [
    extra.dateformat,
    extra.locale,
  ]);

  return { defaultColConfigs };
}

export { useColumns };
